import { SET_ERROR, SET_LOADING } from "@/store/constants/mutation-types";
import {
  MESSAGE_SUCCESS_CATEGORIE_MAPPING,
  MESSAGE_DELETE_CATEGORIE_MAPPING
} from "@/store/constants/messages";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  /**
   * @description Add a mapping category
   * @param commit
   * @param dispatch
   * @param categoryMapping
   * @returns {Promise<void>}
   */
  async addCategoryMapping({ commit, dispatch }, categoryMapping) {
    try {
      commit(SET_LOADING, true, { root: true });
      await this._vm.$gwzApi
        .service("categories")
        .addCategorieMapping(categoryMapping);
      await commit(SET_LOADING, false, { root: true });
      dispatch("setSuccessToast", MESSAGE_SUCCESS_CATEGORIE_MAPPING, {
        root: true
      });
    } catch (err) {
      commit(SET_LOADING, false, { root: true });
      commit(SET_ERROR, true, { root: true });
      dispatch("setErrorToast", err?.message, { root: true });
    }
  },

  /**
   * @description delete Mirakl category
   * @param dispatch
   * @param id - Mirakl category id
   * @returns {Object} - Mirakl Category info or error object
   */
  async deleteCategoryMapping({ commit, dispatch }, id) {
    try {
      commit(SET_LOADING, true, { root: true });
      await this._vm.$gwzApi.service("categories").deleteCategorieMapping(id);
      await commit(SET_LOADING, false, { root: true });
      await dispatch("setSuccessToast", MESSAGE_DELETE_CATEGORIE_MAPPING, {
        root: true
      });
    } catch (err) {
      commit(SET_LOADING, false, { root: true });
      commit(SET_ERROR, true, { root: true });
      dispatch("setErrorToast", err?.message, { root: true });
      return err;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
